import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { ReleaseModeForm } from 'front-office/components/release-mode/form';
import { ReleaseModeCrumbs } from 'front-office/constants/release-mode-crumbs';
import { useEventCallback } from '@mui/material';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const ReleaseModeNew = (): React.ReactElement => {
  const insertReleaseMode = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/modalita-rilascio`,
    {
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {},
      },
    }
  );

  const navigate = useNavigate();

  const onOk = useEventCallback((form: ReleaseModeForm | undefined) => {
    (
      insertReleaseMode({
        data: {
          tipoRegistro: form?.register || undefined,
          descrizione: form?.descriptionRelease || undefined,
          descrizioneModalitaStampa: form?.descriptionPrint || undefined,
          codiceEsenzioneAnpr: form?.exemption || undefined,
          importoImpostaBollo: form?.typePayment?.stamp || undefined,
          importoDirittiSegreteria: form?.typePayment?.secretariat || undefined,
          importoDirittiStatoCivile: form?.typePayment?.maritalStatus || undefined,
          importoDirittiFissi: form?.typePayment?.fixed || undefined,
          importoSpese: form?.typePayment?.expenses || undefined,
          codiceImpDirittiStatoCivile: form?.typePayment?.maritalStatusCode || undefined,
          codiceImpDirittiFissi: form?.typePayment?.fixedCode || undefined,
          codiceImpImpostaBollo: form?.typePayment?.stampCode || undefined,
          codiceImpSpese: form?.typePayment?.expensesCode || undefined,
          codiceImpDirittiSegreteria: form?.typePayment?.secretariatCode || undefined,
          dataInizioValidita: form?.dateFrom ? form?.dateFrom?.toFormat('yyyy-MM-dd') : undefined,
          dataFineValidita: form?.dateTo ? form?.dateTo?.toFormat('yyyy-MM-dd') : undefined,
          codiceUsoModalita: form?.use || undefined,
          key: {
            codiceModalitaRilascio: form?.code || undefined,
          },
        },
      }) as ResponsePromise<void, void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello/modalita-rilascio');
    });
  });

  return (
    <Fragment>
      <Breadcrumbs items={[...ReleaseModeCrumbs, { name: 'Nuova modalità rilascio' }]} />
      <Form
        title="Nuova modalità rilascio"
        onOk={onOk}
        onCancel={() => {
          navigate('/sportello/modalita-rilascio');
        }}
      />
    </Fragment>
  );
};

ReleaseModeNew.displayName = 'Release Mode new page component';

export default ReleaseModeNew;
